import * as React from 'react';
function IconWarning(props) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h24v24H0z" }),
            React.createElement("path", { d: "M11.17 10.91l.2 4.38h1.28l.2-4.38h-1.68zm.84 5.29a.878.878 0 00-.645.265.866.866 0 00-.265.635c0 .253.088.468.265.645a.878.878 0 00.645.265.866.866 0 00.635-.265.878.878 0 00.265-.645.866.866 0 00-.265-.635.866.866 0 00-.635-.265z", fill: "currentColor", fillRule: "nonzero" }),
            React.createElement("path", { d: "M12 3L2 21h20L12 3zm6.601 16H5.399L12 7.118 18.601 19z", fill: "currentColor", fillRule: "nonzero" }))));
}
export default IconWarning;
//# sourceMappingURL=IconWarning.js.map